<template>
  <HeraFormSwitch
    v-if="isTeamTournament()"
    v-model="teamType"
    name="fullTeams"
    :label="$$t('Require full teams', 'require_type_label')"
    :disabled="isButtonDisabled"
    :true-label="$$t('Yes')"
    :false-label="$$t('No')"
    :true-value="true"
    :false-value="false"
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import HeraFormSwitch from '@/components/atoms/form/HeraFormSwitch';
import { translate } from '@/mixins/translate';
export default {
  name: 'SettingsRequireFullTeams',
  components: {
    HeraFormSwitch,
  },
  mixins: [translate('_web_tournament_additional_settings')],
  data() {
    return {
      teamTypeStatus: false,
    };
  },
  computed: {
    ...mapGetters(['currentTournament', 'isTournamentFieldDisabled']),
    teamType: {
      get() {
        return this.$lodash.get(
          this.currentTournament,
          'players_config.full_teams',
          false
        );
      },
      set(val) {
        this.updateCurrentTournament({
          full_teams: val,
          component: 'players_config',
        });
      },
    },
    isButtonDisabled() {
      const entryFeeRequired = this.currentTournament.entry_fee.required;
      const squadSize = this.$lodash.get(
        this.currentTournament,
        'players_config.squad_size',
        0
      );

      return entryFeeRequired && squadSize >= 2;
    },
  },
  watch: {
    'currentTournament.entry_fee.required': {
      handler() {
        this.updateTeamType();
      },
      immediate: true,
    },
    'currentTournament.players_config.squad_size': {
      handler() {
        this.updateTeamType();
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),

    isTeamTournament() {
      return this.currentTournament.players_config.squad_size
        ? this.currentTournament.players_config.squad_size >= 2
          ? true
          : false
        : false;
    },
    updateTeamType() {
      const entryFeeRequired = this.currentTournament.entry_fee.required;
      const squadSize = this.$lodash.get(
        this.currentTournament,
        'players_config.squad_size',
        0
      );

      if (entryFeeRequired && squadSize >= 2) {
        this.teamTypeStatus = true;
        this.teamType = true;
      } else {
        this.teamTypeStatus = true;
        this.teamType = false;
      }
    },
  },
};
</script>
